import { useState, useEffect, useRef } from 'react';
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  ListSubheader,
  TextField,
  InputAdornment,
  Typography
} from '@mui/material';
import { FixedSizeList as List } from 'react-window';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import SearchIcon from '@mui/icons-material/Search';
import './DropdownFilter.scss';

const DropdownFilter = ( { agentData, handleChange, placeholderText, selectedValue, isDisabled, isOpen, setDropdownOpen, errorClass }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [displayedOptions, setDisplayedOptions] = useState(null);
  const filterBoxRef = useRef(null);
  const ITEM_SIZE = 48;
  const containsText = (text, searchQuery) => text.toLowerCase().indexOf(searchQuery.toLowerCase()) > -1;
  useEffect(() => {
    if (agentData) {
      setDisplayedOptions(agentData.filter((agent) => containsText(agent, searchText)));
    }
  }, [agentData, searchText]);

  const handleSelect = (e) => {
    handleChange(e);
  };

  useEffect(() => {
    setSelectedOption((selectedValue !== undefined && ( selectedValue !== 'No results found.' && selectedValue !== 'None') ) ? selectedValue : null);
  }, [selectedValue]);

  useEffect(() => {
    if (filterBoxRef.current) {
      filterBoxRef.current.focus();
    }
  }, [displayedOptions]);

  const handleDropdownToggle = (e) => {
      if (e.target.classList.contains('MuiInputBase-inputAdornedStart')) {
        return;
      }
      setDropdownOpen(!isOpen && !isDisabled);
      setSearchText('');
  };

  const renderRow = (props) => {
    const { index, style } = props;
  
    return (
      <MenuItem
        className='agent-option'
        style={style}
        key={index}
        value={displayedOptions[index]}
        onClick={(event) => handleSelect(event)}
      >
        {displayedOptions[index]}
      </MenuItem>
    );
  };

  return (
    <Box className={errorClass}>
      <FormControl fullWidth>
        {!selectedOption && (
          <InputLabel className='dropdown-text' shrink={false}>
            {placeholderText}
          </InputLabel>
        )}
        <Select
          disabled={isDisabled}
          IconComponent={KeyboardArrowDown}
          sx={{
            '& .MuiSvgIcon-root': {
              color: '#282828',
            },
          }}
          MenuProps={{
            classes: { paper: 'paper-scroll' },
          }}
          displayEmpty
          variant='outlined'
          placeholder='Enter or select code'
          labelId='search-select-label'
          id='search-select'
          value={selectedOption ?? ' '}
          onClose={() => setSearchText('')}
          onClick={(e) => handleDropdownToggle(e)}
          open={isOpen && !isDisabled}
          renderValue={() => selectedOption}
        >
          <ListSubheader>
            <TextField
              className='filter-box'
              variant='outlined'
              autoFocus
              placeholder='Search number or name'
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start' className="filter-box-adornment">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key !== 'Escape') {
                  e.stopPropagation();
                }
              }}
              inputRef={filterBoxRef}
            />
          </ListSubheader>
          {displayedOptions && displayedOptions.length > 0 &&
            <div className="results-scrollbars">
              <List
                height={360}
                itemSize={ITEM_SIZE}
                itemCount={displayedOptions.length}
                overscanCount={5}
              >
                {({ index, style }) => renderRow({ index, style })}
              </List>
            </div>
          }
          {(displayedOptions && displayedOptions.length > 5000) && (
            <Typography className='large-results-text'>5000+ results found, please refine search to find what you're looking for</Typography>
          )}
          {(displayedOptions && displayedOptions.length > 1 && displayedOptions.length < 5000) && (
            <Typography className='results-text'>{displayedOptions.length} results found</Typography>
          )}
        </Select>
      </FormControl>
    </Box>
  );
}

export default DropdownFilter;